import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfPainelPSBoxHorizontal = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : '');

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório de Acompanhamento',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon ' + theme}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" onClick={handlePrint} /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
            <div className="inforow right">
              <h3 style={{ fontSize: '18px' }}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
							{
								BACKEND_URL.includes('gruposanta') ? (
									<img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
								) : null
							}
            </div>
          </div>
          <div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
            <div className='inforow right'>
              <div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Leito</th>
                  <th>Paciente</th>
                  <th>Laboratório</th>
                  <th>Radiologia</th>
                  <th>Medicação </th>
                  <th>Médico</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let statusClass = "ready";
                  let statusLab = "-";
                  let statusRx = "-";
                  let statusFarm = "-";
                  let totalLab = parseInt(parseInt(data.LAB_PENDENTE) + parseInt(data.LAB_LAUDADO));
                  let totalRx = parseInt(parseInt(data.RX_PENDENTE) + parseInt(data.RX_LAUDADO));
                  let totalFarm = parseInt(parseInt(data.FARM_PENDENTE) + parseInt(data.FARM_SEPARADO));
                  let tdClassLab = "";
                  let spanClassLab = "";
                  let tdClassRx = "";
                  let spanClassRx = "";
                  let spanClassFarm = "";
                  let name = data.PACIENTE_NOME.split(' ').slice(-1).join(' ') + ', ' + data.PACIENTE_NOME.split(' ')[0].slice(0, 1);
                  let leito = (data.LEITORESUMO) ? data.LEITORESUMO : (data.LEITO) ? data.LEITO : '-';
                  let medico = data.PRESTADOR_NOME.split(' ')[0] + ' ' + data.PRESTADOR_NOME.split(' ').slice(-1).join(' ');
                  let key = "tr-" + data.ATENDIMENTO + '-' + data.SERVICO;
                  if (data.LAB_LAUDADO > 0) {
                    statusLab = data.LAB_LAUDADO + " de " + totalLab + " disponíveis";
                    tdClassLab = "attention";
                    spanClassLab = "success-circle";
                  } else {
                    if (data.LAB_PENDENTE > 0) {
                      statusLab = "Aguardando " + data.LAB_PENDENTE + " Laudo(s)";
                      tdClassLab = "attention";
                      spanClassLab = "attention-circle";
                    }
                  }

                  if (data.RX_LAUDADO > 0) {
                    statusRx = data.RX_LAUDADO + " de " + totalRx + " disponíveis";
                    tdClassRx = "attention";
                    spanClassRx = "success-circle";
                  } else {
                    if (data.RX_PENDENTE > 0) {
                      statusRx = "Aguardando " + data.RX_PENDENTE + " Laudo(s)";
                      tdClassRx = "attention";
                      spanClassRx = "attention-circle";
                    }
                  }

                  if (data.FARM_SEPARADO > 0) {
                    statusFarm = data.FARM_SEPARADO + " de " + totalFarm + " dispensados";
                    spanClassFarm = "success-circle";
                  } else {
                    if (data.FARM_PENDENTE > 0) {
                      statusFarm = "Aguardando " + data.FARM_PENDENTE + " itens";
                      spanClassFarm = "attention-circle";
                    }
                  }

                  let time = data.DURACAO_ATENDIMENTO;

                  if (data.DURACAO_ATENDIMENTO > 60) {
                    var hours = (data.DURACAO_ATENDIMENTO / 60);
                    var rhours = Math.floor(hours);
                    var minutes = (hours - rhours) * 60;
                    var rminutes = Math.round(minutes);
                    time = rhours + " hs " + rminutes + " mins";
                  } else {
                    time = time + ' mins';
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td>{leito}<br></br>{time}</td>
                      <td><b>{name}</b></td>
                      <td className={tdClassLab}><span className={spanClassLab}></span>{statusLab}</td>
                      <td className={tdClassRx}><span className={spanClassRx}></span>{statusRx}</td>
                      <td className={tdClassRx}><span className={spanClassFarm}></span>{statusFarm}</td>
                      <td><b>{medico}</b></td>
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfPainelPSBoxHorizontal;